import { render, staticRenderFns } from "./rendering copy.vue?vue&type=template&id=e5490df4&scoped=true"
import script from "./rendering copy.vue?vue&type=script&lang=js"
export * from "./rendering copy.vue?vue&type=script&lang=js"
import style0 from "./rendering copy.vue?vue&type=style&index=0&id=e5490df4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5490df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5490df4')) {
      api.createRecord('e5490df4', component.options)
    } else {
      api.reload('e5490df4', component.options)
    }
    module.hot.accept("./rendering copy.vue?vue&type=template&id=e5490df4&scoped=true", function () {
      api.rerender('e5490df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/mainFrom/rendering copy.vue"
export default component.exports